// extracted by mini-css-extract-plugin
export default {"BillingInformation":"PaymentsStyle_BillingInformation__8nXfO","heading":"PaymentsStyle_heading__SofvY","line":"PaymentsStyle_line__VOmiw"};